import React from "react";

const AuthSplitLayout = ({
  imageSrc,
  imageAlt = "auth-image",
  imageOverlay,
  panelClassName = "",
  children,
  footer,
}) => {
  return (
    <div className="w-full h-screen flex">
      {/* Left image panel - hidden below lg breakpoint */}
      <div
        className={`hidden lg:block lg:w-[40%] relative font-[Montserrat] overflow-hidden ${panelClassName}`}
      >
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover object-top"
        />
        {imageOverlay}
      </div>

      {/* Right content panel - full width on mobile, 60% on desktop */}
      <div className="w-full lg:w-[60%] relative flex flex-col items-center justify-center px-6 sm:px-8 md:px-12 lg:px-0">
        <div className="flex-1 flex items-center justify-center w-full">
          {children}
        </div>
        {footer && (
          <div className="py-6 flex justify-center">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthSplitLayout;
